// src/router.js
import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/views/layout/Index.vue'; 
import Home from '@/views/home/Home.vue';
import ProductDetail from '@/components/ProductDetail.vue';
//chat Ai
import ChatAi from '@/components/chatAi.vue';
// 导入文章页面组件
import Article from '@/views/article/Index.vue';  // 文章主页面
import ArticleList from '@/views/article/ArticleList/Index.vue'; // 文章列表页面
import ArticleDetail from '@/views/article/ArticleDetail/Index.vue'; // 文章详情页面

Vue.use(Router);

const routes = [
    {
        path: '/',
        component: Layout,
        children:[
            {
                path:'/',
                name:'home',
                component:Home
            },
           {
            path: '/product/:id', // 动态路由，匹配商品 ID
            name: 'product-detail',
            component: ProductDetail,
            props: true, // 将路由参数作为属性传递给组件
           },
           {
            path: '/ChatAi', 
            name: 'ChatAi',
            component: ChatAi,
           },
        ]
    },
    {
        path: '/article', // 文章主页面
        component: Article,
        children: [
          {
            path: 'article-list', // 文章列表路径
            name: 'article-list', // 推荐使用小写短横线格式
            component: ArticleList,
          },
          {
            path: 'article-detail/:id', // 动态路由，匹配文章 ID
            name: 'article-detail',
            component: ArticleDetail,
            props: true, // 将路由参数作为属性传递给组件
          },
        ],
      },
];

const router = new Router({
    mode: 'history', // 使用历史模式，URL中不会带有#
    routes,
});

export default router;
